// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui'
import './theme/blue/theme/index.css'
import App from './App'
import i18n from './lang'
import router from './router'
import store from './store/store'
import globalMixins from './mixins/globalMixins'
import dialogLoading from './util/dialogLoading'
import {bcadd, bcsub, bcmul, bcdiv, removeHtmlStyle, delayRun} from './util/util'
import VueMeta from 'vue-meta'
Vue.prototype.$math = {
  bcadd, bcsub, bcmul, bcdiv
}
Vue.prototype.$delayRun = delayRun
Vue.prototype.$trimStyle = removeHtmlStyle
Vue.prototype.$EventBus = new Vue()
Vue.use(ElementUI, {
  size: 'mini'
})
Vue.use(VueMeta)
Vue.use(dialogLoading)
Vue.mixin(globalMixins)
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  i18n,
  el: '#app',
  router,
  store,
  metaInfo () {
    return {
      title: this.$store.state.metaInfo.title,
      meta: [
        {
          name: 'keywords',
          content: this.$store.state.metaInfo.keywords
        },
        {
          name: 'description',
          content: this.$store.state.metaInfo.description
        }
      ]
    }
  },
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js